import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { ICommonState, commonTypes } from './types';
import * as commonActions from './actions';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
const INITIAL_STATE: ICommonState = {
  isLoading: false,
  isSubmitting: false,
  showNavbar: false,
  showSidebar: false,
  collapseSidebar: false,
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: ICommonState, payload: UnsafeReturnType<T>): ICommonState;
}

const setLoading: IActionHandler<typeof commonActions['setLoading']> = (state, { payload }) => ({
  ...state,
  isLoading: payload,
});

const setSubmitting: IActionHandler<typeof commonActions['setSubmitting']> = (state, { payload }) => ({
  ...state,
  isSubmitting: payload,
});

const setSidebar: IActionHandler<typeof commonActions['setSidebar']> = (state, { payload }) => ({
  ...state,
  showSidebar: payload,
  showNavbar: payload,
});

const setCollapseSidebar: IActionHandler<typeof commonActions['setCollapseSidebar']> = (state, { payload }) => ({
  ...state,
  collapseSidebar: payload,
});

/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [commonTypes.SET_LOADING]: setLoading,
  [commonTypes.SET_SUBMITTING]: setSubmitting,
  [commonTypes.SET_SIDEBAR]: setSidebar,
  [commonTypes.SET_COLLAPSE_SIDEBAR]: setCollapseSidebar,
};

const commonReducer = createReducer<ICommonState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export { commonReducer, commonTypes, commonActions };
